export enum NewTrackingStep {
    Domain = "domain",
    Keywords = "keywords",
    Complete= "complete",
}